
import React from "react";
import SearchBar from "./SearchBar";
import PaymentFilters from "@/components/payments/PaymentFilters";
import { Filters, InvoiceStatus } from "@/types/payments";

interface SearchAndFilterBarProps {
  searchQuery: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filters: Filters;
  handleFilterChange: (key: keyof Filters, value: any) => void;
  handleStatusFilterChange?: (status: InvoiceStatus | 'all') => void;
  resetFilters: () => void;
  applyFilters: () => void;
  uniqueCurrencies: string[];
  showFilters: boolean;
  setShowFilters: (show: boolean) => void;
  activeFilters?: Filters;
  hasActiveFilters?: boolean;
}

const SearchAndFilterBar: React.FC<SearchAndFilterBarProps> = ({
  searchQuery,
  onSearchChange,
  filters,
  handleFilterChange,
  handleStatusFilterChange,
  resetFilters,
  applyFilters,
  uniqueCurrencies,
  showFilters,
  setShowFilters,
  activeFilters,
  hasActiveFilters
}) => {
  return (
    <div className="flex items-center gap-4">
      <SearchBar
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        className="flex-grow-0"
      />

      <PaymentFilters
        filters={filters}
        handleFilterChange={handleFilterChange}
        handleStatusFilterChange={handleStatusFilterChange}
        resetFilters={resetFilters}
        applyFilters={applyFilters}
        uniqueCurrencies={uniqueCurrencies}
        showFilters={showFilters}
        setShowFilters={setShowFilters}
        hasActiveFilters={hasActiveFilters}
      />
    </div>
  );
};

export default SearchAndFilterBar;
